/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  ConstructEmptyPathwayCourseByType, PathwayCourse, PathwayCourseType
} from '../../../../features/pathways/pathways.model';
import ExpandableCard from '../../../../components/details/ExpandableCard';
import TextInput from '../../../../components/forms/TextInput';
import { AppAssetPaths } from '../../../../app/app.types';
import { Divider } from '@mui/material';
import { useAppSelector } from '../../../../app/hooks';
import { userSelectors } from '../../../../features/user/user.slice';

import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


interface MiddleSchoolCourseFormProps {
  middleSchoolCourseFields: any;
  errors: any;
  appendCourseCallback: (course: PathwayCourse) => void;
  removeCourseCallback: (fieldIndex: number, courseId?: number, ) => void;
  updateCourseCallback: (fieldIndex: number, course: Partial<PathwayCourse>) => void;
  getValuesCallback: (fieldName: string) => any;
}

const MiddleSchoolCourseForm: React.FC<MiddleSchoolCourseFormProps> = ({
  middleSchoolCourseFields,
  errors,
  appendCourseCallback,
  removeCourseCallback,
  updateCourseCallback,
  getValuesCallback,
}) => {

  const user = useAppSelector(userSelectors.selectUser);

  return (
    <ExpandableCard
      className="course-form"
      summary={<span>Middle School/ Jr. High Courses</span>}
      details={
        <div className="course-container">
          {middleSchoolCourseFields.map((c: PathwayCourse, i: number) => (
            <div key={c.id}>
              {i > 0 && <Divider variant="middle" className="divider course-divider" />}
              <div className="flex_jbetween_acenter">
                <p className="course-number">Course {i+1}</p>
                <div className="course-control flex">
                  <span
                    className="hide-button"
                    onClick={() => updateCourseCallback(i, {
                      ...middleSchoolCourseFields[i],
                      name: getValuesCallback(`middleSchoolCourses.${i}.name`),
                      link: getValuesCallback(`middleSchoolCourses.${i}.link`),
                      alternateCourseName: getValuesCallback(`middleSchoolCourses.${i}.alternateCourseName`),
                      active: !middleSchoolCourseFields[i].active,
                    })}
                  >
                    {middleSchoolCourseFields[i].active ? (
                      <div className="flex_acenter">
                        <p>Hide Course</p>
                        <VisibilityIcon className="eye-icon" />
                      </div>
                    ) : (
                      <div className="flex_acenter">
                        <p>Show Course</p>
                        <VisibilityOffIcon className="eye-icon" />
                      </div>
                    )}
                  </span>
                  {user.isAdmin && (
                    <span
                      className="remove-button flex_acenter"
                      onClick={() => removeCourseCallback(i, middleSchoolCourseFields[i].courseId)}
                    >
                      <p>Remove Course</p>
                      <img className="trash-icon" src={AppAssetPaths.icons.TRASH_RED} alt="delete" />
                    </span>
                  )}
                </div>
              </div>
              <div className="form-content flex_row_jbetween">
                <div className="form-column">
                  <TextInput
                    name={`middleSchoolCourses.${i}.name` as 'middleSchoolCourses.0.name'}
                    label="COURSE NAME"
                    errorMessage={errors?.middleSchoolCourses?.[i]?.name?.message}
                    type="text"
                    size="small"
                    disabled={user.isDistrictAdmin || user.isHighSchoolAdmin}
                  />
                  {(user.isDistrictAdmin || user.isHighSchoolAdmin) && (
                    <TextInput
                      name={`middleSchoolCourses.${i}.alternateCourseName` as 'middleSchoolCourses.0.alternateCourseName'}
                      label="ALTERNATIVE COURSE NAME"
                      type="text"
                      size="small"
                      tooltip="If this field is filled out, the text here will replace the the original course name for your school."
                    />
                  )}
                </div>
                <div className="form-column">
                  <TextInput
                    name={`middleSchoolCourses.${i}.link` as 'middleSchoolCourses.0.link'}
                    label="LINK"
                    errorMessage={errors?.middleSchoolCourses?.[i]?.link?.message}
                    type="text"
                    size="small"
                    disabled={user.isDistrictAdmin || user.isHighSchoolAdmin}
                  />
                </div>
              </div>
            </div>
          ))}
          {user.isAdmin && (
            <span
              className="add-button flex_acenter"
              onClick={() => appendCourseCallback(ConstructEmptyPathwayCourseByType(PathwayCourseType.middleSchool))}
            >
              <AddIcon className="add-icon" />
              <p>Add Course</p>
            </span>
          )}
        </div>
      }
      expandable
    />
  );
};

export default MiddleSchoolCourseForm;
